import { render } from "./AppColors.vue?vue&type=template&id=7f35f34e&scoped=true"
import script from "./AppColors.vue?vue&type=script&lang=js"
export * from "./AppColors.vue?vue&type=script&lang=js"

import "./AppColors.vue?vue&type=style&index=0&id=7f35f34e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f35f34e"]])

export default __exports__